"use client";
import SectionPage from "@/components/common/section-page";

import EspaceProTitleCard from "@/components/common/espace-pro-title-card";
import {PageEnConstruction} from "@/components/common/page-en-construction";

export default function Home() {

    return (
        <div className={"flex flex-col gap-6 pb-6 mb-8"}>


            <EspaceProTitleCard title={"Restez Informés"}
                                middleBreadcrumbs={[
                                    {title: "L'Office du Tourisme", link: "/espace-pro/office-de-tourisme"},
                                ]}
                                description={"Découvrez l’équipe de l’Office de Tourisme et les missions que nous menons, en faveur du développement touristique de la destination COTE D’IVOIRE"}/>

            {/* Nature & Biodiversité */}
            <SectionPage sectionType="lg">

               <PageEnConstruction />
            </SectionPage>

        </div>
    );
}
